import {useDuration} from '@hooks';
import {DurationProps} from './types';

export const Duration = ({endDate, number, startDate, timeUnit}: DurationProps) => {
  const {getFormattedDuration} = useDuration();
  return <>{getFormattedDuration({startDate, endDate, number, timeUnit})}</>;
};
